import React from 'react';
import { motion } from 'framer-motion';
import { Search, Zap, DollarSign, Handshake, ShieldCheck, ArrowRight } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/vantixcredit/diagnostico-de-credito';
const offerings = [{
  number: '01',
  icon: Search,
  title: 'Diagnóstico Personalizado',
  description: 'Realizamos un análisis profundo de tu perfil crediticio para entender exactamente dónde estás y diseñar una estrategia que funcione específicamente para ti, ya que cada caso es único y se trata de forma totalmente personalizada.'
}, {
  number: '02',
  icon: Zap,
  title: 'Estrategia de Optimización Experta',
  description: 'Nuestro equipo diseña un plan paso a paso para remover cuentas negativas y errores que pueda tener tu reporte de crédito, en vías de mejorar, estructurar y fortalecer tu perfil personal. Nuestro objetivo es claro: que los bancos e instituciones financieras te vean como un candidato ideal para aprobarte con las mejores condiciones y los intereses más bajos.'
}, {
  number: '03',
  icon: DollarSign,
  title: 'Acceso a Capital Real',
  description: 'Una vez optimizado tu crédito, logramos abrir las puertas al financiamiento: desde $35,000 hasta $50,000 dólares a través de uno o más bancos, líneas de crédito, préstamos personales y credit card stacking estratégico para maximizar tu capital, para que puedas impulsar tu negocio, hacer inversiones o emprender desde cero.'
}, {
  number: '04',
  icon: Handshake,
  title: 'Acompañamiento en Todo el Proceso',
  description: 'Contarás con atención personalizada en cada etapa del proceso, donde podrás consultar y resolver las dudas que tengas acerca de tu caso. Recibirás actualizaciones sobre los resultados que vamos obteniendo y contarás con nuestra guía para llegar a los +700 puntos.'
}];
export function Commitment() {
  return <section className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-45" data-mp="3jkrb8jz4y59j">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-46" data-mp="3l3hfra6ckuj7" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-47" data-mp="3c29uptsudq72">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-48" data-mp="3c4chm4yp737k">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-49" data-mp="2xcu54h51rqsy">
            Qué Incluye el Servicio
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-50" data-mp="2obdvibm23sps">
            Qué Ofrecemos y{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-51" data-mp="24sq44c79pfe8">
              Garantías de Servicio
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-52" data-mp="2emqk5943851q">
            Más que un servicio, una asociación estratégica para transformar tu
            vida financiera de principio a fin.
          </p>
        </motion.div>

        {/* 2x2 grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-53" data-mp="2ipvgsv1hlcig">
          {offerings.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: index % 2 * 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} className="p-8 md:p-10 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/[0.08] hover:border-amber-500/20 transition-all duration-500" data-id="element-54" data-mp="2xhdu2l2yosy4" data-mpi={index}>
              <div className="flex items-center gap-4 mb-6" data-id="element-55" data-mp="1eftuue59a3wd">
                <div className="h-12 w-12 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center shrink-0" data-id="element-56" data-mp="gtwfuqq34gp6">
                  <item.icon className="h-6 w-6 text-amber-400" strokeWidth={2} data-id="element-57" data-mp="qqiyr9yuoxok" />
                </div>
                <span className="text-sm font-semibold tracking-[0.3em] bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-58" data-mp="uqjb8p2e2ysz">
                  {item.number}
                </span>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-59" data-mp="3qptuw0kdy9zs">
                {item.title}
              </h3>
              <p className="text-white/50 font-light leading-relaxed" data-id="element-60" data-mp="3mnq8igw6hkzq">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        {/* Guarantee banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="rounded-3xl border border-amber-500/30 bg-gradient-to-r from-amber-500/[0.08] via-amber-500/[0.03] to-transparent shadow-2xl shadow-amber-500/5 p-8 md:p-12" data-id="element-61" data-mp="3cz8cecyug22f">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8" data-id="element-62" data-mp="x5810eda6hbb">
            {/* Icon */}
            <div className="h-16 w-16 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center shrink-0" data-id="element-63" data-mp="s6dasrczhqh6">
              <ShieldCheck className="h-8 w-8 text-amber-400" strokeWidth={2} data-id="element-64" data-mp="1g4ue3ibyt861" />
            </div>

            {/* Text */}
            <div className="flex-1" data-id="element-65" data-mp="12abjht29j8ya">
              <div className="text-xs font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-4" data-id="element-66" data-mp="17ag2bpqn8fro">
                Garantía de Servicio
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight" data-id="element-67" data-mp="1z141wxco5d38">
                Si no logramos una mejora visible en tu reporte de crédito en
                120 días, te devolvemos el{' '}
                <span className="bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-68" data-mp="1pzw40ge2ee9o">
                  100%
                </span>{' '}
                de tu inversión.
              </h3>
              <p className="text-white/50 font-light leading-relaxed" data-id="element-69" data-mp="731530vsebyk">
                Este acuerdo lo realizamos bajo contrato firmado por ambas
                partes para garantizar que todo se haga correctamente.
              </p>
            </div>

            {/* CTA */}
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-7 py-4 rounded-full transition-all text-base shadow-2xl shadow-amber-500/30 shrink-0 whitespace-nowrap" data-id="element-70" data-mp="g2xx9chdxsyd">
              Empieza Ahora
              <ArrowRight className="h-4 w-4" data-id="element-71" data-mp="3ojsply0k3uy7" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}